import { IArticle, IDirectOrderedArticleLine, IQuantityPerUnit } from '@alberta/konexi-shared';
import { ignore } from 'src/app/common/tracking/tracker';
import { TotalPriceCalculator } from 'src/app/patient/components/patient-detail/sections/integratedcare/direct-order-edit/direct-order-invoice-data/totalPrice-calculator';
import { ArticleDto } from 'src/app/shared/models/article/article-dto.model';
import { v4 } from 'uuid';

import { QuantityPerUnit } from '../../shared/models/article/quantityPerUnit';

export class DirectOrderArticleLineViewModel implements IDirectOrderedArticleLine {
  _id: string;
  articleId: string;
  articleCustomerNumber: string;
  packagingUnitId: string;
  unit: string;
  quantity: number;
  price: string;
  attributes: Record<string, any>;
  timestamp: Date;
  archived: boolean;
  deliveredQuantity: number;
  bookingCode: string;
  serialNumber: string;
  batchNumber: string;
  isPrivateSale: boolean;
  storageLocation: string;

  @ignore()
  article: IArticle = new ArticleDto();
  @ignore()
  packagingUnit: IQuantityPerUnit;
  @ignore()
  isNew: boolean;
  @ignore()
  active: boolean;
  @ignore()
  totalPrice: string;

  constructor() {
    this._id = v4();
    this.timestamp = new Date();
    this.archived = false;
    this.packagingUnit = new QuantityPerUnit();
  }

  public initialize(article: IArticle) {
    if (!article) {
      return false;
    }

    this.articleId = article._id;
    this.article = article;
    this.articleCustomerNumber = article.customerNumber;
    if (!article.packagingUnits || !article.packagingUnits.length) {
      return false;
    }
    if (this.packagingUnitId) {
      return true;
    }
    this.price = this.article?.listPrice;
    const defaultPackagingUnit = article.packagingUnits.find((f: any) => f.defaultPackagingUnit);
    this.packagingUnit = defaultPackagingUnit || article.packagingUnits[0] || new QuantityPerUnit();

    if (!this.packagingUnit) {
      return false;
    }
    this.quantity === 0 ? (this.quantity = 0) : (this.quantity = this.quantity || 1);
    this.unit = this.packagingUnit.unit;
    this.packagingUnitId = this.packagingUnit._id;

    return true;
  }

  public calculateTotalPrice() {
    if (!this.price || !this.quantity) {
      return;
    }

    this.totalPrice = TotalPriceCalculator.calculateArticleTotal(
      this.price,
      this.quantity,
      this.packagingUnit?.quantity
    );
  }
}
